/**
 * Explore drawer: the text shown next to the sort icon in the column header.
 *
 * Display-only. The header used to render `insightFieldsSelectorLabel` straight
 * from config/Insights.ts ("Total Win" / "Total Play"). That field is shared with
 * other surfaces, and the Explore drawer's money metrics were renamed to
 * "$ Won" / "$ Played", so the sort label is resolved here from the selected
 * insight instead. Metrics without an override keep their configured label.
 *
 * Keys are InsightValueEnum values (a plain string map keeps this file free of
 * config imports). Sort order, API params and the insight data path are not
 * touched by this label.
 */
export const EXPLORE_SORT_LABEL_OVERRIDES: Readonly<Record<string, string>> = {
  money_won: '$ Won',
  money_played: '$ Played',
};

export const getExploreSortLabel = (
  insightValue: string | null | undefined,
  fallbackLabel?: string
): string | undefined => {
  if (
    insightValue &&
    Object.prototype.hasOwnProperty.call(EXPLORE_SORT_LABEL_OVERRIDES, insightValue)
  ) {
    return EXPLORE_SORT_LABEL_OVERRIDES[insightValue];
  }
  return fallbackLabel;
};
